var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSocket(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#010101",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M63.951.001C28.696.001.001 28.696.001 63.951s28.695 63.95 63.95 63.95s63.95-28.695 63.95-63.95S99.206.001 63.95.001zm0 10.679c29.484 0 53.272 23.787 53.272 53.271s-23.788 53.272-53.272 53.272s-53.272-23.787-53.272-53.272S34.467 10.68 63.951 10.68",
    color: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.39 60.716c14.004-11.44 27.702-23.278 42.011-34.384c-7.505 11.533-15.224 22.913-22.729 34.445c-6.437.03-12.875.03-19.282-.061m11.838 6.376c6.468 0 12.905 0 19.342.092c-14.095 11.38-27.732 23.309-42.071 34.384c7.505-11.533 15.224-22.943 22.729-34.476"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocket);
export default __webpack_public_path__ + "static/media/socket.3255fb60ed01e5797dfa7620d6342026.svg";
export { ForwardRef as ReactComponent };